import { render } from "./BlogContent.vue?vue&type=template&id=13bd7830"
import script from "./BlogContent.vue?vue&type=script&lang=js"
export * from "./BlogContent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__